import React, {useState, useEffect} from 'react';
import '../styles/doctors.css';
import { PhoneCall, House, Mail } from 'lucide-react';
import '../styles/about-mnh.css';




const doctors=
  [
    {
        "id":0,
        "name":"Dr. G. S. De",
        "degrees":"MBBS, MS (Surgery)",
        "timings":"Every day morning from 11 a.m. & evening from 6 p.m., except Sunday",
        "designation":"Consultant General Surgeon",
        "img":require("../assets/img/doctors/doc-1.png")
    },
    {
        "id":1,
        "name":"Dr. Avidip De",
        "degrees":"MBBS, MS (Surgery), Fellowship: GI-HPB Surgery (Tata Medical Center)",
        "timings":"Every day morning from 10 a.m. & evening from 6 p.m. except Sunday",
        "designation":"Consultant Laparoscopic & GI Onco-Surgeon | LAP APR for cancer surgery first time out side kolkata",
        "img":require("../assets/img/doctors/doc-2.png")
    },
    {
        "id":2,
        "name":"Dr. Abhijit Das",
        "degrees":"Achievements: Gold Medalist Additional Qualifications: DNB, ECMO, CEPIC, PDCR, MNAMSFellowship: Clinical Oncology (Tata Medical Center)",
        "timings":"Every Sunday from 11 a.m",
        "designation":"Consultant Medical & Radiation Oncologist",
        "img":require("../assets/img/doctors/doc-3.png")
    },
    {
        "id":3,
        "name":"Dr. Avisek De",
        "degrees":"MBBS, MD (Radiodiagnosis)",
        "timings":"Every day morning 8 a.m. to 2 p.m. except Sunday",
        "designation":"Consultant Radiologist",
        "img":require("../assets/img/doctors/doc-4.png")
    },
    {
        "id":4,
        "name":"Dr. Barun Saha",
        "degrees":"MBBS, MS, MCh (Urology)",
        "timings":"Last Thursday of every month from 6 p.m. (with prior appointment)",
        "designation":"Consultant Uro-Surgeon, PCNL, URSL, TURP",
        "img":require("../assets/img/doctors/doc-5.png")
    },
    {
        "id":5,
        "name":"Dr. D. P. Das",
        "degrees":"MBBS, MS, MCh (Urology)",
        "timings":"2nd & 4th Sunday every month from 8 a.m. (with prior appointment)",
        "designation":"Consultant Uro-Surgeon",
        "img":require("../assets/img/doctors/doc-6.png")
    },
    {
        "id":6,
        "name":"Dr. Partha Chakraborty",
        "degrees":"MBBS, MS, MCh (Paediatric Surgery)",
        "timings":"Every Sunday from 10 a.m.",
        "designation":"Consultant Paediatric Surgeon, Consultant Hypospadias Orchidopexy",
        "img":require("../assets/img/doctors/doc-7.png")
    },
    {
        "id":7,
        "name":"Dr. Rana Barik",
        "degrees":"MBBS, MD (Pulmonary Medicine)",
        "timings":"Every Tuesday from 1 p.m.",
        "designation":"Consultant Pulmonologist",
        "img":require("../assets/img/doctors/doc-8.png")
    },
    {
        "id":8,
        "name":"Dr. Monoranjan Sow",
        "degrees":"MBBS, MS (Surgery) Fellowship: MCh (Plastic & Reconstructive Surgery) Achievements: Gold Medalist",
        "timings":"Every Sunday from 10 a.m.",
        "designation":"Consultant Plastic & Reconstructive Surgeon",
        "img":require("../assets/img/doctors/doc-9.png")
    },
    {
        "id":9,
        "name":"Dr. Snehasis Ghosh",
        "degrees":"MD (Medicine), Dip. Card. (Cardiology)",
        "timings":"Every Tuesday & Friday from 8 a.m.",
        "designation":"Consultant General Physician & Cardiologist",
        "img":require("../assets/img/doctors/doc-10.png")
    },
    {
        "id":10,
        "name":"Dr. Somenath Das",
        "degrees":"MBBS, MD (Dermatology)",
        "timings":"Every Thursday & Saturday from 1 p.m.",
        "designation":"Consultant Dermatologist",
        "img":require("../assets/img/doctors/doc-11.png")
    },
    {
        "id":11,
        "name":"Dr. Ranbir Singh",
        "degrees":"MBBS, MD (Pathology) Fellowship: DM (Onco-Pathology) (Tata Medical Center)",
        "timings":"Every Sunday from 1 p.m.",
        "designation":"Consultant Pathologist",
        "img":require("../assets/img/doctors/doc-12.png")
    },
    {
        "id":12,
        "name":"Dr. Jitamanyu Maity",
        "degrees":"MBBS (Kol), DPM (IPGMER), MIPS",
        "timings":"By appointment",
        "designation":"Consultant Neuro Psychiatrist | Ex-Calcutta National Medical College, Kol. | Ex-Attached to IIMSAR & BC Roy Hospital | Haldia Antara Neuro Psychiatry Hospital (Kol)",
        "img":require("../assets/img/doctors/doc-13.png")
    },
    {
        "id":13,
        "name":"Dr. Dalliya Roy",
        "degrees":"MBBS, MS (Gynaec & Obs)",
        "timings":"Every Monday to Wednesday, by appointment",
        "designation":"Consultant Obstetrician & Gynaecologist",
        "img":require("../assets/img/doctors/doc-14.png")
    },
    {
        "id":14,
        "name":"Sritama Banerjee",
        "degrees":"B.Sc, M.Sc (Medical Nutritional Therapy)",
        "timings":"By appointment",
        "designation":"Consultant Clinical Dietitian, Nutritionist & Diabetes Educator",
        "img":require("../assets/img/doctors/doc-15.png")
    }
];
function Doctors() {
  const [doctorsData, setDoctorsData] = useState([]);
  useEffect(() => {
    // Simulating data fetch
    setDoctorsData(doctors);
  }, []);
  return (
    <>
    <div className="doctors-container">
      <div className="doctors-top-panel">
        <img
          src={require("../assets/img/doctors/topPanel.jpg")}
          alt="Doctors Top Panel"
          className="doctors-top-panel-img"
        />
        <div className="gallery-overlay-title">
          Care Led by Experienced Doctors
          <p style={{fontWeight:'normal', fontSize:'35px',lineHeight:'1',color:'#FFFFFF', textAlign:'center'}}>Our team of qualified specialists is committed to safe and ethical treatment.</p>
        </div>
      </div>
    </div>
    <div className="home-carousel-row">
        <div className="home-carousel-col">
          <div className="carousel-col-content">
            <PhoneCall size={48} color="#fff" />
            <span className="carousel-col-title">
              In Emergency give us a call<br />
              9434007688
            </span>
          </div>
        </div>
        <div className="home-carousel-col">
          <div className="carousel-col-content">
            <House  size={48} color="#fff" />
            <span className="carousel-col-title">
              Get our Location<br />
              Dangalpara, Suri, Birbhum
            </span>
          </div>
        </div>
        <div className="home-carousel-col">
          <div className="carousel-col-content">
            <Mail size={48} color="#fff"/>
            <span className="carousel-col-title">
              Send an email<br />
              mdnhsuribir@gmail.com
            </span>
          </div>
        </div>
      </div>
    <div className="doctors-description-panel" style={{marginTop:'50px'}}>
      <p>
        {/* Removed FontAwesomeIcon usage to fix eslint error */}
        Our team of doctors includes qualified and experienced medical professionals across multiple specialties. Each doctor is committed to providing responsible, ethical, and patient-focused care, with clear communication and appropriate medical guidance.
      </p>
      <p>Patients can review doctor profiles to understand areas of specialization, qualifications, and consultation timings before requesting an appointment.</p>
    </div>
    <div className="doctors-details-panel" style={{backgroundColor:'#dbedf8',padding:'20px'}}>
      <div className="row justify-content-center g-0">
        {Array.isArray(doctorsData) && doctorsData.length > 0 ? (
              doctorsData.map((item, index) => (
                <div className="card" style={{
                  width: 350,
                  marginLeft:'20px',
                  marginRight:'20px',
                  marginBottom: '30px',
                  
                  boxShadow: '0 4px 8px 0 rgba(0, 0, 0, 0.2)',
                  padding: '26px',}} key={item.id || item.title}>
                  <img src={item.img} alt={item.title} 
                  style={{
                    width: window.innerWidth <= 400 ? 200 : 350 || window.innerWidth <= 1000 ? 200 : 350,
                    height: window.innerWidth <= 400 ? 200 : 350 || window.innerWidth <= 1000 ? 200 : 350,
                    marginTop: '16px',
                    borderRadius: '8px',
                    objectFit: 'cover',
                    display: 'block',
                    marginLeft: 'auto',
                    marginRight: 'auto',
                  }}/>
                  <span><h1>{item.name}</h1></span>
                  <span><p>{item.degrees}</p></span>
                  <hr/>
                  <span><p>{item.designation}</p></span>
                  <hr/>
                  <span><p>{item.timings}</p></span>
                </div>
              ))
            ) : null}
      </div>
    </div>
    </>
  );
}

export default Doctors;
